import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {TextField, MenuItem} from "@mui/material";
import {useTranslation} from "react-i18next";
import {DateTime} from "luxon";
import {range} from "lodash";
import {LANGUAGE_PATH} from "modules";
import {FormLabelStyled} from "apps/DRAW_PREDICTOR/components/Form";
import {IDateProps} from "apps/DRAW_PREDICTOR/modules/types";

const Wrap = styled.div``;

const DOBWrap = styled.div``;

const MonthDiv = styled.div``;
const DayDiv = styled.div``;
const YearDiv = styled.div``;

const FlexBetween = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const months = [
	"registration.month.january",
	"registration.month.february",
	"registration.month.march",
	"registration.month.april",
	"registration.month.may",
	"registration.month.june",
	"registration.month.july",
	"registration.month.august",
	"registration.month.september",
	"registration.month.october",
	"registration.month.november",
	"registration.month.december",
];

type eventType = React.ChangeEvent<HTMLInputElement>;

interface IProps {
	onDateChange: ({dobDay, dobMonth, dobYear}: IDateProps) => void;
}

export const Datepicker: React.FC<IProps> = ({onDateChange}) => {
	const [dobDay, setDobDay] = useState(0);
	const [dobMonth, setDobMonth] = useState(0);
	const [dobYear, setDobYear] = useState(0);
	const [maxDayInMonth, setDaysInMonth] = useState(
		DateTime.fromJSDate(new Date(2000, 0)).daysInMonth
	);
	const {t} = useTranslation(LANGUAGE_PATH);

	const handleDayChange = (event: eventType) => {
		setDobDay(Number(event.target.value));
	};
	const handleMonthChange = (event: eventType) => {
		const month = Number(event.target.value);
		setDobMonth(month);
		setDaysInMonth(DateTime.fromJSDate(new Date(dobYear, month - 1)).daysInMonth);
	};
	const handleYearChange = (event: eventType) => {
		const year = Number(event.target.value);
		setDobYear(year);
		setDaysInMonth(DateTime.fromJSDate(new Date(year, dobMonth - 1)).daysInMonth);
	};

	useEffect(() => {
		if (dobDay && dobMonth && dobYear) {
			onDateChange({dobDay, dobMonth, dobYear});
		}
	}, [dobDay, dobMonth, dobYear, onDateChange]);

	const isDayValid = Boolean(dobDay > maxDayInMonth);
	const maxYear = new Date().getFullYear() - 10;
	const isYearValid = Boolean(dobYear > maxYear);

	return (
		<Wrap>
			<DOBWrap>
				<FormLabelStyled>{t("register.form.date_of_birth")}</FormLabelStyled>
			</DOBWrap>
			<FlexBetween>
				<MonthDiv>
					<TextField
						sx={{m: 1, minWidth: 100}}
						select={true}
						size="small"
						margin="normal"
						variant="standard"
						color="secondary"
						value={dobMonth}
						onChange={handleMonthChange}>
						<MenuItem value={0}>{t("register.form.month")}</MenuItem>
						{months.map((month, monthIndex) => (
							<MenuItem key={monthIndex + 1} value={monthIndex + 1} dense={true}>
								{t(month)}
							</MenuItem>
						))}
					</TextField>
				</MonthDiv>
				<DayDiv>
					<TextField
						sx={{m: 1, minWidth: 100}}
						select={true}
						name="day"
						type="number"
						size="small"
						onChange={handleDayChange}
						value={dobDay}
						error={isDayValid}
						variant="standard"
						InputLabelProps={{
							shrink: true,
						}}>
						<MenuItem value={0}>{t("register.form.day")}</MenuItem>
						{range(1, maxDayInMonth + 1).map((day, dayIndex) => (
							<MenuItem key={dayIndex + 1} value={dayIndex + 1} dense={true}>
								{day}
							</MenuItem>
						))}
					</TextField>
				</DayDiv>
				<YearDiv>
					<TextField
						sx={{m: 1, minWidth: 100}}
						select={true}
						name="year"
						type="number"
						size="small"
						onChange={handleYearChange}
						value={dobYear}
						error={isYearValid}
						variant="standard"
						InputLabelProps={{
							shrink: true,
						}}>
						<MenuItem value={0}>{t("register.form.year")}</MenuItem>
						{range(1900, maxYear).map((year, yearIndex) => (
							<MenuItem key={yearIndex + 1} value={yearIndex + 1} dense={true}>
								{year}
							</MenuItem>
						))}
					</TextField>
				</YearDiv>
			</FlexBetween>
		</Wrap>
	);
};
